//
// GENERATED by KVision
//
package pl.finn.forms.tw1

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.tw1.Tw1Form
import pl.finn.forms.tw1.Tw1FormData

actual class Tw1Service(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : ITw1Service, KVRemoteAgent<Tw1Service>(Tw1ServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(ITw1Service::nowy, token)
    override suspend fun edycja(token: String) = call(ITw1Service::edycja, token)
    override suspend fun sprawdz(tw1Form: Tw1Form, zalaczniki: List<Zalacznik>, token: String) = call(ITw1Service::sprawdz, tw1Form, zalaczniki, token)
    override suspend fun zapisz(tw1Form: Tw1Form, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(ITw1Service::zapisz, tw1Form, zalaczniki, validateResult, token)
    override suspend fun podglad(tw1Form: Tw1Form, zalaczniki: List<Zalacznik>, token: String) = call(ITw1Service::podglad, tw1Form, zalaczniki, token)
}
